import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import CreditPlan from '../../containers/credit-plan';

import OneColumnLayout from '../../blocks/one-column-layout';
import TwoColumnLayout from '../../blocks/two-column-layout';
import ThreeColumnLayout from '../../blocks/three-column-layout';
import FourColumnLayout from '../../blocks/four-column-layout';

const CreditPlanBlock = props => <CreditPlan {...props} />;
CreditPlanBlock.displayName = 'CreditPlan';

export default withDynamicComponents({
  componentWhitelist: [
    OneColumnLayout,
    TwoColumnLayout,
    ThreeColumnLayout,
    FourColumnLayout,
  ],
  mapInputToOutput: [
    ['images', 'images'],
    ['mbImages', 'mbImages'],
  ],
})(CreditPlanBlock);



// WEBPACK FOOTER //
// ./src/blocks/credit-plan/index.jsx